// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Practice-Main-index-root-3Mxlu","singleLay":"src-components-Practice-Main-index-singleLay-n-T8f","doubleLayout":"src-components-Practice-Main-index-doubleLayout-C4n9o","explain":"src-components-Practice-Main-index-explain-3SxaX","questionContent":"src-components-Practice-Main-index-questionContent-3NjHh","questionBox":"src-components-Practice-Main-index-questionBox-3RAVA","writingStem":"src-components-Practice-Main-index-writingStem-16oHw"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Practice/Main/index.css
 ** module id = 127
 ** module chunks = 0
 **/